import React from 'react';
import style from "./deposit.module.css";
import { setHeader } from '../../store/settings/settingsSlice';
import { useDispatch,useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import ng_icon from '../../assets/images/ng.svg'
import ghana_icon from '../../assets/images/ghanaflag.svg'
import usd_icon from '../../assets/images/usd.svg'
import bitcoinIcon from '../../assets/images/bitcoin.svg'
import ethIcon from "../../assets/images/ethereum-eth-logo.png";
import ltcIcon from "../../assets/images/litecoin-ltc-logo.svg";
import usdtIcon from "../../assets/images/tether-usdt-logo.svg";
import xrpIcon from "../../assets/images/xrp-xrp-logo.svg";
import dogeIcon from "../../assets/images/dogecoin-doge-logo.svg";
import trxIcon from "../../assets/images/tron-trx-logo.svg";
import bnbIcon from "../../assets/images/bnb-bnb-logo.svg";
import usdcIcon from "../../assets/images/usd-coin-usdc-logo.svg";
import solIcon from "../../assets/images/solana-sol-logo.svg";
import xlmIcon from "../../assets/images/stellar-xlm-logo.svg";
import arrowCircleRight from '../../assets/images/arrow-circle-right.svg'
import { useNavigate } from 'react-router-dom';
import Modal from '../modal/Modal';
import { getCryptoCoins } from '../../store/settings/settingsActions';
import { getWalletBalance } from '../../store/wallet/walletActions';

const depositTypes = [
  { code: "FIAT", label: "Fiat" },
  { code: "CRYPTO", label: "Crypto" }
];


const coinIcons = {
  BTC: bitcoinIcon,
  ETH: ethIcon,
  LTC: ltcIcon,
  USDT: usdtIcon,
  XRP: xrpIcon,
  DOGE: dogeIcon,
  TRX: trxIcon,
  BNB: bnbIcon,
  USDC: usdcIcon,
  SOL: solIcon,
  XLM: xlmIcon,
};

const fiatAssetMeta = {
  NGN: {
    name: "Naira",
    symbol: "NGN",
    icon: ng_icon,
    pricePrefix: "₦",
  },
  GHS: {
    name: "Ghana Cedis",
    symbol: "CEDIS",
    icon: ghana_icon,
    pricePrefix: "GH₵",
  },
  USD: {
    name: "US Dollar",
    symbol: "USD",
    icon: usd_icon,
    pricePrefix: "$",
  },
};


const DepositPage = () => {
 const dispatch = useDispatch();
  const [location, setLocation] = useState("FIAT");
  const navigate = useNavigate();
  const [isCryptoModalOpen, setIsCryptoModalOpen] = useState(false);
  const {cryptocoins, loading} = useSelector((state) => state.settings)
   const walletData = useSelector((state) => state.wallet.data);
    const fiatWallets = walletData?.fiatWallets || [];

    const mappedCryptoAssets = (cryptocoins || []).map(asset => ({
    code: asset.currency?.toUpperCase(),
    id: asset.quidaxUserId,
    name: asset.name,
    symbol: asset.currency?.toUpperCase(),
    icon: coinIcons[asset.currency?.toUpperCase()] || bitcoinIcon,
    price: `${asset.currency?.toUpperCase()} ${asset.balance || "0.00"}`,
    change: asset.price_change_percentage
        ? `${asset.price_change_percentage > 0 ? "+" : ""}${asset.price_change_percentage.toFixed(2)}%`
        : "0.00%",
    changeUp: asset.price_change_percentage > 0,
    }));

    const mappedFiatAssets = fiatWallets
    .filter(wallet => wallet.is_active && wallet.Currency?.code !== "USD")
    .map(wallet => {
        const code = wallet.Currency?.code;
        const meta = fiatAssetMeta[code] || {};
        return {
        code,
        name: meta.name || wallet.Currency?.name || code,
        symbol: meta.symbol || code,
        icon: meta.icon,
        price: `${meta.pricePrefix || ""}${parseFloat(wallet.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        id: wallet.id,
        comingSoon: code === "GHS",
        };
    });
 
  
const [selectedCrypto, setSelectedCrypto] = useState(null);
    
    useEffect(() => {
        dispatch(setHeader("Deposit"));    
        dispatch(getCryptoCoins())    
        dispatch(getWalletBalance());
     }, [dispatch]);

    return (  
        <>

       <Modal
        title={`Receive ${selectedCrypto?.name || ""}`}
        minWidth="40%"
        canClose
        modalOpen={isCryptoModalOpen}
        setModalOpen={setIsCryptoModalOpen}
        >
        <div style={{ marginTop: '18px', textAlign: 'center' }}>
            <p style={{
            color: '#B6B6B6',
            fontSize: 14,
            marginBottom: 32,
            marginTop: 0,
            fontWeight: 400,
            }}>
            Please select one of the options below to receive funds<br />into your wallet
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <div 
            className={style.cryptoModalOption}
             onClick={() => {
                setIsCryptoModalOpen(false);
                navigate(
                `/deposit-with-crypto?option=wallet-address&currency=${selectedCrypto?.code}&id=${selectedCrypto?.id}`
                );
            }}
            >
                <div className={style.cryptoModalIconWrap}>
                {/* Example SVG icon for wallet */}
                <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M2 7.5A2.5 2.5 0 0 1 4.5 5h15A2.5 2.5 0 0 1 22 7.5v9A2.5 2.5 0 0 1 19.5 19h-15A2.5 2.5 0 0 1 2 16.5v-9Z" stroke="#40196D" strokeWidth="1.5"/><circle cx="17" cy="12" r="1" fill="#40196D"/></svg>
                </div>
                <div>
                <div className={style.cryptoModalOptionTitle}>Wallet Address</div>
                <div className={style.cryptoModalOptionDesc}>Receive funds using your wallet address</div>
                </div>
                <div className={style.cryptoModalArrow}>
                     <img src={arrowCircleRight} alt="arrow right" />
                </div>
            </div>
            <div
             className={style.cryptoModalOption}
                onClick={() => {
                    setIsCryptoModalOpen(false);
                    navigate(
                        `/deposit-with-crypto?option=internal-transfer&currency=${selectedCrypto?.code}&id=${selectedCrypto?.id}`
                    );
                }}
             >
                <div className={style.cryptoModalIconWrap}>
                {/* Example SVG icon for internal transfer */}
                   <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="6" cy="12" r="2" stroke="#40196D" strokeWidth="1.5"/><circle cx="18" cy="6" r="2" stroke="#40196D" strokeWidth="1.5"/><circle cx="18" cy="18" r="2" stroke="#40196D" strokeWidth="1.5"/><path d="M7.76 10.62l2.48-1.24M7.76 13.38l2.48 1.24M15.52 7.24l-2.48 1.24M15.52 16.76l-2.48-1.24" stroke="#40196D" strokeWidth="1.5"/></svg>
                </div>
                <div>
                <div className={style.cryptoModalOptionTitle}>Internal Transfer</div>
                <div className={style.cryptoModalOptionDesc}>Receive funds from a Astro user</div>
                </div>
                <div className={style.cryptoModalArrow}>
                    <img src={arrowCircleRight} alt="arrow right" />
                </div>
            </div>
            </div>
        </div>
        </Modal>

        <div
            className={style.cashTabs}
        >
            <ul>
               {depositTypes.map((type) => {
                const isSelected = location === type.code;
                return (
                    <li
                    key={type.code}
                    onClick={() => setLocation(type.code)}
                    style={{
                        borderBottom: isSelected
                        ? "3px #40196D solid"
                        : "0px #90909039 solid",
                    }}
                    >
                    <div>
                        <p
                        style={{
                            color: isSelected ? "#40196D" : "#C1C1C1",
                        }}
                        >
                        {type.label}
                        </p>
                    </div>
                    </li>
                );
                })}
            </ul>
        </div>

        {location === "FIAT" && (
            <>
                <p className={style.depositSubtitle}>Select the asset you want to deposit.</p>
                 <div className={style.fiatAssetsList}>
      {mappedFiatAssets.length === 0 ? (
        <div style={{ width: "100%", textAlign: "center", padding: "40px 0", color: "#909090" }}>
          No fiat wallets found.
        </div>
      ) : (
      mappedFiatAssets.map(asset => (
          <div
            className={style.fiatAssetCard}
            key={asset.code}
            onClick={
              asset.comingSoon
                ? undefined
                : () => navigate(`/deposit-with-fiat?currency=${asset.code}`)
            }
            style={{
              cursor: asset.comingSoon ? "not-allowed" : "pointer",
              opacity: asset.comingSoon ? 0.6 : 1,
              position: "relative"
            }}
          >
            <div className={style.fiatAssetInfo}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: '#FFFFFF',
                justifyContent: 'center',
              }}>
                <img src={asset.icon} alt={asset.name} className={style.fiatAssetIcon} />
              </div>
              <div>
                <div className={style.fiatAssetName}>{asset.name}</div>
                <div className={style.fiatAssetSymbol}>{asset.symbol}</div>
              </div>
            </div>
            <div className={style.fiatAssetPriceBlock}>
              <div className={style.fiatAssetPrice}>{asset.price}</div>
            </div>
            {asset.comingSoon && (
              <div style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "#FFD700",
                color: "#40196D",
                padding: "2px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: 600,
              }}>
                Coming Soon
              </div>
            )}
          </div>
        ))
      )}
    </div>
            </>
        )}

      
        {location === "CRYPTO" && (
                <>
                    <p className={style.depositSubtitle}>Select the asset you want to deposit.</p>
                    <div className={style.cryptoAssetsList}>
                    {loading ? (
                        <div style={{ width: "100%", textAlign: "center", padding: "40px 0" }}>
                        Loading...
                        </div>
                    ) : mappedCryptoAssets.length === 0 ? (
                        <div style={{ width: "100%", textAlign: "center", padding: "40px 0", color: "#909090" }}>
                        No crypto assets found.
                        </div>
                    ) : (
                        mappedCryptoAssets.map(asset => (
                        <div 
                            className={style.fiatAssetCard}
                            key={asset.code}
                            onClick={() => {
                            setSelectedCrypto(asset);
                            setIsCryptoModalOpen(true);
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className={style.fiatAssetInfo}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '60px',
                                height: '60px',
                                borderRadius: '50%',
                                backgroundColor: '#FFFFFF',
                                justifyContent: 'center',
                            }}>
                                <img src={asset.icon} alt={asset.name} className={style.fiatAssetIcon} />
                            </div>
                            <div>
                                <div className={style.fiatAssetName}>{asset.name}</div>
                                <div className={style.fiatAssetSymbol}>{asset.symbol}</div>
                            </div>
                            </div>
                            <div className={style.fiatAssetPriceBlock}>
                            <div className={style.fiatAssetPrice}>{asset?.price || "0.00"}</div>
                            <div className={asset.changeUp ? style.fiatAssetChangeUp : style.fiatAssetChangeDown}>
                                {asset.changeUp ? "↑" : "↓"} {asset.change}
                            </div>
                            </div>
                        </div>
                        ))
                    )}
                    </div>
                </>
                )}

        </>
    );
}
 
export default DepositPage;